import { IVbPlaybackTokenConfig } from './IVbPlaybackTokenConfig';
import { IVbSource } from './IVbSource';

export class PlaybackOption implements IVbSource {
	public is360Enabled: boolean;
	public isDefault: boolean;
	public isLive: boolean;
	public isUnavailable: boolean;
	public label: string;
	public qValue: number;
	public src: string;
	public srcObject?: any;
	public srcOptions: IVbSource[];
	public tokenConfig: IVbPlaybackTokenConfig;
	public authHeader?: string;
	public type: string;
	public isC2paEligible?: boolean;

	constructor(optionInput: IVbSource) {
		// merge optionInput data
		Object.assign(this, optionInput, {
			isUnavailable: false,
			srcOptions: []
		});
	}
	public fallback(): void {
		const fallbackOption = this.srcOptions.shift();

		if (fallbackOption) {
			Object.assign(this, fallbackOption);
			this.isUnavailable = false;
		}
	}
	public addSrcOption(option: IVbSource): void {
		this.srcOptions.push(option);

		this.isDefault = this.isDefault || option.isDefault;
	}
}
